import {
  LegalPageLayout,
  LegalSection,
  LegalParagraph,
  LegalBulletList,
} from './LegalPage'

export function TermsOfServicePage() {
  return (
    <LegalPageLayout title="Lightstrike App Terms of Service">
      <LegalParagraph>
        These Terms of Service (&quot;Terms&quot;) govern your use of the
        Lightstrike app, provided by Lightstrike LLC (&quot;we&quot;,
        &quot;us&quot;, or &quot;our&quot;). By accessing or using the app,
        you agree to be bound by these Terms.
      </LegalParagraph>

      <LegalSection heading="Eligibility">
        <LegalBulletList
          items={[
            'Age Requirement: You must be at least 13 years of age to use the app. If you are under 18, you must have parental or guardian consent.',
            'Account Registration: You must register for an account to access certain features of the app. You agree to provide accurate, current, and complete information during the registration process.',
          ]}
        />
      </LegalSection>

      <LegalSection heading="User Conduct">
        <LegalBulletList
          items={[
            "Acceptable Use: You agree not to use the app for unlawful purposes or in ways that could damage, disable, overburden, or impair the app or interfere with any other party's use.",
            'Prohibited Activities: You are prohibited from engaging in activities such as hacking, distributing viruses, posting or distributing illegal content, or infringing on intellectual property rights.',
          ]}
        />
      </LegalSection>

      <LegalSection heading="Intellectual Property">
        <LegalBulletList
          items={[
            'Ownership: All rights, title, and interest in the app, including all intellectual property rights, are owned by or licensed to us.',
            'License to Use: We grant you a limited, non-exclusive, non-transferable, revocable license to use the app in accordance with these Terms.',
          ]}
        />
      </LegalSection>

      <LegalSection heading="Subscription Services">
        <LegalBulletList
          items={[
            'Fees and Payment: Some features of the app may require payment. All fees are as described in the app and are subject to change.',
            'Automatic Renewal: Subscriptions may automatically renew unless canceled at least 24 hours before the end of the current period.',
          ]}
        />
      </LegalSection>

      <LegalSection heading="Termination">
        <LegalParagraph>
          We may terminate or suspend your access to the app immediately,
          without prior notice or liability, if you breach these Terms.
        </LegalParagraph>
      </LegalSection>

      <LegalSection heading="Disclaimers and Limitations of Liability">
        <LegalBulletList
          items={[
            'As-Is Basis: The app is provided "as is" and "as available" without any warranties, express or implied.',
            'Limitation of Liability: To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues.',
          ]}
        />
      </LegalSection>

      <LegalSection heading="Indemnification">
        <LegalParagraph>
          You agree to indemnify and hold harmless Lightstrike LLC, its
          officers, directors, employees, and agents, from any and all claims,
          damages, obligations, losses, liabilities, costs, and expenses
          arising from your use of the app or your violation of these Terms.
        </LegalParagraph>
      </LegalSection>

      <LegalSection heading="Changes to Terms">
        <LegalParagraph>
          We reserve the right to modify these Terms at any time. We will
          provide notice of any significant changes and update the &quot;Last
          Updated&quot; date at the top of these Terms.
        </LegalParagraph>
      </LegalSection>

      <LegalSection heading="Governing Law">
        <LegalParagraph>
          These Terms shall be governed by and construed in accordance with
          the laws of the jurisdiction in which our company is registered,
          without regard to its conflict of law provisions.
        </LegalParagraph>
      </LegalSection>

      <LegalSection heading="Contact Information">
        <LegalParagraph>
          For any questions about these Terms, please contact us at
          hello@lightstrikelabs.com.
        </LegalParagraph>
      </LegalSection>

      <LegalParagraph>
        By using the Lightstrike app, you acknowledge that you have read,
        understood, and agree to be bound by these Terms of Service.
      </LegalParagraph>
    </LegalPageLayout>
  )
}
